export default {
  name: 'change-model',
  translationKey: 'change-model-module',
  routePrefix: 'change-model',
  routeNamePrefix: 'change-model',
  directRoutesAvailable: false,
}
